import SideBar from "../../../Components/SideBar/SideBar"
import { SearchBar } from "../../../Components/SearchBar"
import DownloadXlsx from "../../../Utils/TableUtils/DownloadXlsx"
import { useState, useEffect, useCallback } from "react"
import axios from "axios"
import SepaTable from "./SepaTable"
import { createDataSepa, createDataSepaMcdo } from "../../../Utils/TableUtils/createData"
import { removeAccents } from "../../../Utils/Regex/removeAccents"

const apiUrl = process.env.REACT_APP_API_URL

function Sepa() {
    const [sepaMandates, setSepaMandates] = useState([])

    const [signedSepaMandates, setSignedSepaMandates] = useState([])
    const [filteredSignedSepaMandates, setFilteredSignedSepaMandates] = useState([])

    const [pendingSepaMandates, setPendingSepaMandates] = useState([])
    const [filteredPendingSepaMandates, setFilteredPendingSepaMandates] = useState([])
    const [page, setPage] = useState(0)
    const [pageSigned, setPageSigned] = useState(0)

    const [isDataLoading, setIsDataLoading] = useState(false)

    const [searchValueACompleter, setSearchValueACompleter] = useState("")
    const [searchValueSigne, setSearchValueSigne] = useState("")

    const [isMcdo, setIsMcdo] = useState(false)

    const fetchSepaMandates = useCallback(() => {
        setIsDataLoading(true)
        axios.get(`${apiUrl}/Mandat/Sepa`,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                withCredentials: true,
            })
            .then((response) => {
                let formatedSepa = []
                if (response.data?.some(element => element.numRestaurantMCDO)) {
                    formatedSepa = response.data?.map(element => createDataSepaMcdo(element.raisonSociale, element.numRestaurantMCDO ? parseInt(element.numRestaurantMCDO) : "", element.sites.join(' '), `${element.adresse ? element.adresse : ""} ${element.codePostal ? element.codePostal : ""} ${element.ville ? element.ville : ""}`, element.iban, element.ribFichier, element.mandatFichier, element.dateCreation, element.statut, element.ribID, element.mandatID, element.sepaID))
                }
                else {
                    formatedSepa = response.data?.map(element => createDataSepa(element.raisonSociale, element.sites.join(' '), `${element.adresse ? element.adresse : ""} ${element.codePostal ? element.codePostal : ""} ${element.ville ? element.ville : ""}`, element.iban, element.ribFichier, element.mandatFichier, element.dateCreation, element.statut, element.ribID, element.mandatID, element.sepaID))
                }
                setSepaMandates(formatedSepa)

                const signedSepa = formatedSepa.filter((element) => element.statut === "Signé")
                setSignedSepaMandates(signedSepa)
                setFilteredSignedSepaMandates(signedSepa)

                const pendingSepa = formatedSepa.filter((element) => element.statut === "A compléter / signer")
                setPendingSepaMandates(pendingSepa)
                setFilteredPendingSepaMandates(pendingSepa)

                if (response.data?.some(element => element.numRestaurantMCDO)) setIsMcdo(true)
            })
            .catch(error => {
                if (error?.response?.status === 401) {
                    window.location.reload()
                }
            })
            .finally(() => setIsDataLoading(false))
    }, [])

    useEffect(() => {
        fetchSepaMandates()
    }, [fetchSepaMandates])


    const filterSepaMandates = (query, table) => {
        const keys = ['raisonSociale', 'numRestaurantMCDO', 'sites', 'adresse', 'iban', 'ribFichier', 'mandatFichier', 'dateCreation']
        if (!query || query === "") {
            if (table === "Signé") setFilteredSignedSepaMandates(signedSepaMandates)
            if (table === "A compléter / signer") setFilteredPendingSepaMandates(pendingSepaMandates)
        }
        else if (table === "A compléter / signer") {
            const results = pendingSepaMandates.filter((row) => (
                keys.some((key) => {
                    const k = row?.[key] ?? ''
                    return (removeAccents(k.toString()).includes(removeAccents(query)))
                }
                )))
            setFilteredPendingSepaMandates(results)
            setPage(0)
        }
        else {
            const results = signedSepaMandates.filter((row) => (
                keys.some((key) => {
                    const k = row?.[key] ?? ''
                    return (removeAccents(k.toString()).includes(removeAccents(query)))
                }
                )))
            setFilteredSignedSepaMandates(results)
            setPageSigned(0)
        }
    }

    const getDocument = (documentID, ribFichier) => {
        axios.get(`${apiUrl}/document/${documentID}`,
            {
                withCredentials: true,
                ContentType: 'application/json',
                responseType: 'blob',
            })
            .then((response) => {
                const href = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }))

                const link = document.createElement('a')
                link.href = href

                link.setAttribute('download', ribFichier)
                document.body.appendChild(link)
                link.click()
                link.remove()
                window.URL.revokeObjectURL(href)
            })
            .catch(error => {
                if (error?.response?.status === 401) {
                    window.location.reload()
                }
            })
    }

    const getCleanedData = () => {
        let signedSepaCleaned = JSON.parse(JSON.stringify(filteredSignedSepaMandates))
        signedSepaCleaned.forEach(element => {
            element.mandatID = ""
            element.ribID = ""
            element.sepaID = ""
        });

        return signedSepaCleaned
    }

    return (
        <>
            <SideBar
                active="Sepa"
                openAccount />
            <div className="homepage--container privatepages--container">
                <h3 className="privatepages--title privatepages--text">Mes mandats SEPA</h3>
                <div className="privatepages--separator"></div>
                <div className="table--tablecontainer">
                    {isDataLoading ?
                        <span className="global--loader"></span>
                        :
                        <>
                            {sepaMandates.length === 0 ?
                                <span>Aucun mandat trouvé</span>
                                :
                                <>
                                    {pendingSepaMandates.length > 0 &&
                                        <>
                                            <h5 className="sepa--table__title">A compléter / signer</h5>
                                            <div className="table--searchbarcontainer sepa--table__searchbarcontainer">
                                                <SearchBar
                                                    id="invoicestable"
                                                    filterData={(query) => filterSepaMandates(query, "A compléter / signer")}
                                                    setValue={setSearchValueACompleter}
                                                    value={searchValueACompleter}
                                                    additionnalFormClassName="searchbar--form table--form"
                                                />
                                            </div>
                                        </>
                                    }
                                    {filteredPendingSepaMandates.length > 0 &&
                                        <>
                                            <SepaTable
                                                getDocument={getDocument}
                                                rows={filteredPendingSepaMandates}
                                                page={page}
                                                setPage={setPage}
                                                isMcdo={isMcdo}
                                            />
                                        </>
                                    }
                                    {(filteredPendingSepaMandates.length === 0 && pendingSepaMandates.length > 0) &&
                                        <span>Aucun mandat à compléter trouvé</span>
                                    }
                                    {signedSepaMandates.length > 0 && <h5 className={`sepa--table__title ${pendingSepaMandates.length > 0 ? "sepa--table__searchbarcontainerbottom" : ""}`}>Signé{filteredSignedSepaMandates.length > 1 ? "s" : ""}</h5>}
                                    <div className={`table--searchbarcontainer sepa--table__searchbarcontainer`}>
                                        {signedSepaMandates.length > 0 &&
                                            <>
                                                <SearchBar
                                                    id="invoicestable"
                                                    filterData={(query) => filterSepaMandates(query, "Signé")}
                                                    setValue={setSearchValueSigne}
                                                    value={searchValueSigne}
                                                    additionnalFormClassName="searchbar--form table--form"
                                                />
                                            </>
                                        }
                                        {filteredSignedSepaMandates.length > 0 &&
                                            <DownloadXlsx
                                                data={getCleanedData()}
                                                fileName="mandats_sepa.xlsx"
                                                headRow={isMcdo ?
                                                    [{ "A1": 'Raison sociale', "B1": 'Num. Resto', "C1": 'Site(s) concerné(s)', "D1": 'Adresse', "E1": 'IBAN', "F1": 'RIB', "G1": 'Mandat SEPA', "H1": "Date de création", "I1": "Statut", "J1": "", "K1": "", "L1": "", "M1": "" }] :
                                                    [{ "A1": 'Raison sociale', "B1": 'Site(s) concerné(s)', "C1": 'Adresse', "D1": 'IBAN', "E1": 'RIB', "F1": 'Mandat SEPA', "G1": "Date de création", "H1": "Statut", "I1": "", "J1": "", "K1": "", "L1": "" }]}
                                            />}
                                    </div>
                                    {filteredSignedSepaMandates.length > 0 &&
                                        <>
                                            <SepaTable
                                                getDocument={getDocument}
                                                rows={filteredSignedSepaMandates}
                                                page={pageSigned}
                                                setPage={setPageSigned}
                                                isMcdo={isMcdo}
                                            />
                                        </>
                                    }
                                    {(filteredSignedSepaMandates.length === 0 && signedSepaMandates.length > 0) &&
                                        <span> Aucun mandat signé trouvé</span>
                                    }
                                </>
                            }
                        </>
                    }
                </div>
            </div >
        </>
    )
}

export default Sepa;